import React from "react";
import {
  isArchivedRequest,
  archivedDate,
  formatRequestDate,
} from "../../utils/tenderFormatters";

/**
 * The one badge that says "this row has ended and lives in the archive".
 *
 * Sibling of RequestDraftBadge and written in the same language: a small
 * tinted pill in the card's existing badge row, neutral grey because an
 * archived request is neither an alert nor a promotion. It carries the
 * archiving date from `archived_at` — the design handoff's status pill
 * ("Closed · Mar 12") with the package's own word, since manual close, the
 * inactivity sweep and a concluded deal all land here, not only "closed".
 *
 * Renders nothing at all for a live row, so every call site can mount it
 * unconditionally.
 */
const RequestArchivedBadge = ({ tender, className = "" }) => {
  if (!isArchivedRequest(tender)) return null;

  const when = archivedDate(tender);
  return (
    <span
      className={`px-2 py-0.5 text-[10px] font-semibold rounded-full whitespace-nowrap bg-[#F1F5F9] text-[#45556C] ${className}`}
    >
      {when ? `Archived · ${formatRequestDate(when)}` : "Archived"}
    </span>
  );
};

export default RequestArchivedBadge;
